export default __webpack_public_path__ + "static/media/misc-books1-2048w.aa93ca2c.png";